const Form072PICSTC = {
    picsTitle: "個人資料收集聲明",
    subtitleList: [
        { text: "收集個人資料的目的" },
        { text: "可獲轉移資料者" },
        { text: "查閱個人資料" },
    ],
    symbolStep: [{ step: "(a)" }, { step: "(b)" }, { step: "(c)" }],
    firstStep: [
        {
            text: "你在本表格提供的個人資料，會供教育局用於通函所提及的用途，以及執行教育相關的規則及規例，包括《教育條例》（香港法例第279章）。",
        },
        {
            text: "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理本表格。",
        },
        {
            text: "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        },
        {
            text: "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向助理教育主任（學校行政）42 提出（地址：香港添馬添美道2號政府總部東翼5樓或電郵：<a href='mailto: aeosa42@edb.gov.hk'>aeosa42@edb.gov.hk</a>）。",
        },
    ],
    secondStep: [],
    thirdStep: [
        {
            text: "政府其他政策局及部門以用於上文第1段所述的用途； ",
        },
        {
            text: "你曾就披露個人資料給予訂明同意；以及",
        },
        {
            text: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
    ],
};
export default Form072PICSTC;
